import React from "react";
import { ShieldCheck, Thermometer, Clock, Sparkles, Home as HomeIcon, BadgeCheck, DollarSign, HeartHandshake } from "lucide-react";
import { GUARANTEES } from "@/data/guarantees";

const ICONS = { ShieldCheck, Thermometer, Clock, Sparkles, House: HomeIcon, BadgeCheck, DollarSign, HeartHandshake };

export default function GuaranteesGrid({ className = "" }) {
  return (
    <div className={`grid sm:grid-cols-2 lg:grid-cols-4 gap-5 ${className}`} data-testid="guarantees-grid">
      {GUARANTEES.map((g, i) => {
        const Icon = ICONS[g.icon] || ShieldCheck;
        return (
          <div key={i} data-testid={`guarantee-card-${i}`} className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all">
            <span className="inline-flex items-center justify-center h-11 w-11 rounded-md bg-launch/10 text-launch"><Icon className="h-6 w-6" /></span>
            <h3 className="mt-4 text-base font-bold text-navy leading-snug">{g.title}</h3>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed">{g.desc}</p>
          </div>
        );
      })}
    </div>
  );
}
